"use strict";
// this is not consumed by the client; the back-end uses to keep track of previously delivered stories
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryDay = void 0;
var StoryDay;
(function (StoryDay) {
    StoryDay["monday"] = "monday";
    StoryDay["tuesday"] = "tuesday";
    StoryDay["wednesday"] = "wednesday";
    StoryDay["thursday"] = "thursday";
    StoryDay["friday"] = "friday";
    StoryDay["saturday"] = "saturday";
    StoryDay["sunday"] = "sunday";
})(StoryDay = exports.StoryDay || (exports.StoryDay = {}));
